module.exports = __webpack_public_path__ + "media/images/unite1-b0cd928fec2483c1f4ef69907bb8e136.png";